import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { newsRoute } from '.'

const NewsDetails = lazyRouteComponent(() => import('../../pages/news/news-details'))

export const newsDetailsRoute = createRoute({
  getParentRoute: () => newsRoute,
  path: '$slug',
  component: NewsDetails,
})
